import SectionLanding from '../components/SectionLanding';

// Cards come from the Продукти entry in navConfig, so this page always offers
// exactly the options the sidebar does.
export default function ProductPage() {
  return <SectionLanding sectionName="Продукти" />;
}
